import { SelectModeData } from "PFApp/booking/booking_edit_mode_store";
import { BookingFormDetailsPanelData } from "PFApp/booking/components/booking_form";
import { OverbookingsManagementState } from "PFApp/booking/components/booking_form/overbookings_management_context/overbookings_management_context";
import { ReassignActionData } from "PFApp/booking/parts/overview/booking_module_calendar/context/reassign_action_context_provider";
import { BookingDetailSidePanelProfile } from "PFApp/booking/parts/overview/detail_view/booking_detail/booking_detail_side_panel_context/booking_detail_side_panel_context.types";
import { Overbooking, Row } from "PFApp/booking/types";
import { TemplateKey } from "PFApp/constants/templates";
import { ActivityWarning } from "PFCore/hooks/queries/activity";
import { Booking, CalendarRange, Id } from "PFTypes";

import { BookingFormMode } from "../booking_form";

export enum DetailsPanelType {
  Booking = "booking",
  Role = "role",
  Engagement = "engagement",
  Profile = "profile",
  Overbookings = "overbookings",
  Misalignments = "misalignments",
  Reassign = "reassign",
  BookingForm = "bookingForm"
}

export enum DetailsPanelSource {
  BookingModuleProjects = "bookingModuleProjects",
  BookingModuleWorkforce = "bookingModuleWorkforce"
}

type MisalignmentDetails = {
  profileId: Id | undefined;
  activityIds: Id[];
  enableGoToDate: boolean;
  potentialMisalignments?: ActivityWarning[];
};

export type DetailsPanelData = {
  id: Id;
  type: DetailsPanelType;
  openAllocateManually?: boolean;
  isEditPermitted?: boolean;
  overbookingsDetails?: OverbookingsDetailsPanelData;
  misalignmentDetails?: MisalignmentDetails;
  reassignDetails?: {
    bookingIds: number[];
    bulkSelection?: SelectModeData | null;
    onSubmit?: VoidFunction;
  };
  suspendedProfileDetails?: BookingDetailSidePanelProfile;
  source?: DetailsPanelSource;
  activeBookingIndex?: number;
  setActiveBookingIndex?: (index: number | undefined) => void;
  onClose?: () => void;
  classes?: {
    show?: string;
  };
  bookingDetails?: {
    onDeleted?: (booking: Booking) => Promise<void>;
    onEdited?: () => void;
  };
  bookingModuleDetails?: {
    goToDate?: (date: Date) => void;
    checkCanGoToDate?: (date: string) => boolean;
    calendarRange?: CalendarRange;
    updateOverbookedBookings?: (data: OverbookingsManagementState | null) => void;
    openReassignModal?: (data: ReassignActionData) => void;
    onFilterByProfile?: (data: { profileId: number }) => void;
  };
  bookingFormDetails?: BookingFormDetailsPanelData;
} & Partial<Pick<Row, "original">>;

export type BookingFormDetails = {
  mode?: BookingFormMode;
  initialBookingId?: number;
};

export type OverbookingPotentialBooking = Pick<Booking, "start_date" | "end_date" | "title"> & {
  booking_category_id?: number;
  key: string;
};

export type OverbookingsFilterConfig = {
  showAllOverbookingsEnabled: boolean;
  filteredActivityIds: Id[];
};

type OverbookingsDetailsPanelData = {
  // overbookings panel may be opened in the context of activity
  // but without an ability to filter overbookings by activities (i.e., from Booking Form potential warnings)
  activityIdsContext?: Id[];
  filterConfig?: OverbookingsFilterConfig;
  calendarRange: CalendarRange;
  onShowClick?: (date: Date) => void;
  potentialBookings?: OverbookingPotentialBooking[];
  potentialOverbookings?: Overbooking[];
};

export const activityTypeToSidePanelTypeMap = {
  [TemplateKey.Role]: DetailsPanelType.Role,
  [TemplateKey.AuditRole]: DetailsPanelType.Role,
  [TemplateKey.Engagement]: DetailsPanelType.Engagement,
  [TemplateKey.AuditEngagement]: DetailsPanelType.Engagement
} as const;
